// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"BoxProductBrandRefresh_pageWrapper__1GBd2"};